import { render } from "./EmpresasCrear.vue?vue&type=template&id=372f58be"
import script from "./EmpresasCrear.vue?vue&type=script&lang=js"
export * from "./EmpresasCrear.vue?vue&type=script&lang=js"

import "./EmpresasCrear.vue?vue&type=style&index=0&id=372f58be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__